/**
 * Shared active-route matcher for nav components (G-074/G-097).
 *
 * Boundary-aware prefix match: "/bookings" must NOT light up the "/book" item
 * (`"/bookings".startsWith("/book")` is true — the old bug), but "/bookings/123"
 * must light up "/bookings", and "/manager/customers/:id" must light up
 * "/manager/customers". "/" only matches exactly.
 */
export function isNavActive(pathname: string, to: string): boolean {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(to + "/");
}
